import { useEffect } from "react";
import {
  createColumn,
  createEditAction,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_BANK_ACCOUNTS } from "../../utils/urls";
import useGet from "../common/useGet";
import {
  API_AVAILABLE_LIQUIDATION_BANK_CODES,
  API_BANK_ACCOUNTS,
  API_MERCHANTS_USERS,
} from "../../utils/apis";
import { IFormSection } from "../../types/common";
import { BooleanTags } from "../../components/common/registerUtils";
import { FormActions } from "../../components/common/FormActions";

export const useBankAccounts = () => {
  const tableColumns = () => [
    createColumn("merchant_name", true, "Merchant Name"),
    createColumn("bank_name", true, "Bank Name"),
    createColumn("bank_code", true, "Bank Code"),
    createColumn("account_number", true, "Account Number"),
    createColumn("is_reconciled", true, "Is Reconciled"),
    createColumn("is_active", true, "Is Active"),
    createColumn("actions", false, "Actions"),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        is_active: <BooleanTags status={item?.is_active} />,
        is_reconciled: <BooleanTags status={item?.is_reconciled} />,
        actions: (
          <FormActions
            actions={[createEditAction(URL_BANK_ACCOUNTS, item?.id)]}
          />
        ),
      };
    }),
  ];

  //   const viewData = (item: any) => {};

  const formRoute = getForm(URL_BANK_ACCOUNTS);

  return { tableColumns, tableData, formRoute };
};

export const useBankAccountsForm = () => {
  const {
    data: users,
    loadData: loadUsers,
    loading: usersLoading,
    error: usersError,
  } = useGet();
  const {
    loadData: getAvailableLiquidationBankCodes,
    data: availableLiquidationBankCodes,
  } = useGet();

  useEffect(() => {
    loadUsers({ api: API_MERCHANTS_USERS });
    getAvailableLiquidationBankCodes({
      api: API_AVAILABLE_LIQUIDATION_BANK_CODES,
    });
  }, []);

  const sections: IFormSection[] = [
    {
      title: "Bank Account",
      fields: [
        {
          field_name: "user",
          label: "User",
          type: "select",
          props: { required: true },
          options_data: users?.map((user: any) => ({
            id: user?.id,
            name: user?.name,
          })),
        },
        {
          field_name: "bank_code",
          label: "Bank Code",
          type: "select",
          props: { required: true },
          options_data: availableLiquidationBankCodes?.map((bank: any) => ({
            id: bank.key,
            name: bank.value,
          })),
        },
        {
          field_name: "account_number",
          label: "Account Number",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "is_reconciled",
          label: "Is Reconciled",
          type: "select",
          props: { required: true },
          options_data: [
            { id: true, name: "Yes" },
            { id: false, name: "No" },
          ],
        },
      ],
    },
  ];

  const redirect = getRegister(URL_BANK_ACCOUNTS);

  return { sections, usersLoading, usersError, redirect };
};

export function submitBankAccounts(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: API_BANK_ACCOUNTS,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_BANK_ACCOUNTS,
    params: {
      ...payload,
    },
  };
}
